module.exports = "https://web-assets.ifttt.com/packs/media/docs/trigger_field_static-5d191721.gif";